<template>
  <div>
    <section class="hero is-small is-light">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Wähle deinen Nickname</h1>
          <h2 class="subtitle"></h2>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="columns is-multiline is-mobile">
          <div
            class="column is-half is-offset-one-quarter"
            v-for="item in coffees"
            :key="item.nickname"
          >
            <button
              @click="orderCoffee(item.nickname)"
              class="button is-medium is-fullwidth"
            >{{item.nickname}}</button>
          </div>   
        </div>
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
      </div>
    </section>
  </div>
</template>

<script>
import Store from '../store';

export default {
  name: "home",
  data() {
    return {
      nicknames: [],
      isLoading: false,
    };
  },
  computed: {
      coffees() {
        return Store.state.coffees;
      }
  },
  methods: {
    async orderCoffee(nickname) {
      this.isLoading = true;
      try {
        const response = await this.$Amplify.API.put(
          "coffees",
          "/coffees/order",
          {
            body: { nickname }
          }
        );
        this.isLoading = false;
        // push the success route
        this.$router.push(`/order/${nickname}/success`);
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }    
    }
  },
  mounted() {
    this.isLoading = true;
    Store.dispatch('fetchCoffees').then(_ => this.isLoading = false).catch( _ => this.isLoading = false);
  }
};
</script>

<style>
</style>

